module.exports = __webpack_public_path__ + "img/avatar.bfbe276d.jpg";